import { Tooltip, TooltipContent, TooltipTrigger } from "../ui";

import { cn } from "@/common/lib";

export const TruncateTooltip = ({ text, className }: { text: string; className?: string }) =>
  text.length > 15 ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn("w-36 truncate cursor-pointer", className)}>{text}</div>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  ) : (
    <p className={className}>{text}</p>
  );
